/** Explicit user capture only: no network, scheduling or game state access. */
interface PixelReader {
  drawingBufferWidth: number; drawingBufferHeight: number; RGBA: number; UNSIGNED_BYTE: number;
  readPixels(x: number, y: number, width: number, height: number, format: number, type: number, pixels: Uint8Array): void;
}
export function captureFramePixels(gl: PixelReader, render: () => void) {
  const width = gl.drawingBufferWidth, height = gl.drawingBufferHeight, pixels = width * height;
  if (!Number.isSafeInteger(pixels) || width <= 0 || height <= 0 || pixels > 16_000_000) {
    throw new Error('Pixel capture requires a positive buffer of at most 16 million pixels');
  }
  const data = new Uint8Array(pixels * 4);
  render();
  gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, data);
  let navy = 0;
  for (let i = 0; i < data.length; i += 4) {
    if (Math.abs(data[i]! - 26) + Math.abs(data[i + 1]! - 26) + Math.abs(data[i + 2]! - 46) <= 20) navy++;
  }
  return { width, height, pixels, navyFraction: navy / pixels };
}
interface DiagnosticTexture { destroyed?: boolean; source?: { destroyed?: boolean; width?: number; height?: number } }
export function inspectTextureReferences(sprites: Iterable<{ visible: boolean; texture?: DiagnosticTexture }>) {
  const result = { total: 0, visible: 0, empty: 0, destroyed: 0 };
  for (const sprite of sprites) {
    result.total++;
    if (!sprite.visible) continue;
    result.visible++;
    const texture = sprite.texture;
    if (!texture || texture.destroyed) { result.destroyed++; continue; }
    const source = texture.source;
    if (!source || source.destroyed) result.destroyed++;
    else if ((source.width ?? 0) <= 1 || (source.height ?? 0) <= 1) result.empty++;
  }
  return result;
}
